import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { S as StateOptions } from './state-options.js';
import { n as numberOnlyHandler } from './utils3.js';
import { d as defineCustomElement$4 } from './custom-popper2.js';
import { d as defineCustomElement$3 } from './form-control-select2.js';
import { d as defineCustomElement$2 } from './form-control-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const IdentityAddressForm = /*@__PURE__*/ proxyCustomElement(class IdentityAddressForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = (name, value) => {
            this.address[name] = value;
            this.address = Object.assign({}, this.address);
        };
        this.handleFormUpdate = undefined;
        this.errors = undefined;
        this.defaultValues = undefined;
        this.address = {};
    }
    handleAddressChange(newValues) {
        this.handleFormUpdate(newValues);
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return (h(Host, { key: 'fee663d501d8ed69d8959f3edbb7d40c8d599ed1' }, h("div", { key: '62cf6575afc3a416efbf262d9ad9e9999fd0b480', class: "row gy-3" }, h("div", { key: '353941d7f75be1a8f607bcfd6796e84c2923c5d4', class: "col-12 col-md-8" }, h("form-control-text", { key: '029374e05a1a4523223eff583b29c264d12c34b9', name: "line1", label: "Street Address", defaultValue: (_a = this.defaultValues) === null || _a === void 0 ? void 0 : _a.line1, errorText: (_b = this.errors) === null || _b === void 0 ? void 0 : _b.line1, inputHandler: this.inputHandler, helpText: "\u200B\u200BEnter your address exactly as stated on your driver's license. No PO Boxes." })), h("div", { key: '5a6efdc6724785c67088a9325c427d7594061db7', class: "col-12 col-md-4" }, h("form-control-text", { key: '42b98d49c6e3ccce6c4f27f0edc0b45199ad2011', name: "line2", label: "Apartment, Suite, etc. (optional)", defaultValue: (_c = this.defaultValues) === null || _c === void 0 ? void 0 : _c.line2, errorText: (_d = this.errors) === null || _d === void 0 ? void 0 : _d.line2, inputHandler: this.inputHandler })), h("div", { key: '6e8019d952b5c9b2a1eb1a291a3768e0b1281a10', class: "col-12" }, h("form-control-text", { key: '46a9ccdaa06d6f7bcc83589122fb84661091898a', name: "city", label: "City", defaultValue: (_e = this.defaultValues) === null || _e === void 0 ? void 0 : _e.city, errorText: (_f = this.errors) === null || _f === void 0 ? void 0 : _f.city, inputHandler: this.inputHandler })), h("div", { key: '60d5dd274bdafbe4fa9a690cd552e680028c6e5c', class: "col-12 col-md-6" }, h("form-control-select", { key: '132d048d21dff090951ffdec6812be06d13be30c', name: "state", label: "State", defaultValue: (_g = this.defaultValues) === null || _g === void 0 ? void 0 : _g.state, options: StateOptions, errorText: (_h = this.errors) === null || _h === void 0 ? void 0 : _h.state, inputHandler: this.inputHandler })), h("div", { key: '1f583d9c35eb86fd7067c619bde6d39120ac9581', class: "col-12 col-md-6" }, h("form-control-text", { key: '34ae70fda0faab6da9c5a278203144ecebce15b3', name: "postal_code", label: "Postal Code", defaultValue: (_j = this.defaultValues) === null || _j === void 0 ? void 0 : _j.postal_code, errorText: (_k = this.errors) === null || _k === void 0 ? void 0 : _k.postal_code, maxLength: 5, keyDownHandler: numberOnlyHandler, inputHandler: this.inputHandler })), h("div", { key: 'b04acb1677d176d7b8ab3086c7ac85ece03a9f31', class: "col-12" }, h("form-control-select", { key: '77bd3623328cfb5e090838adb729edc4138134fa', name: "country", label: "Country", options: [{ label: 'United States', value: 'USA' }], inputHandler: this.inputHandler, defaultValue: (_l = this.defaultValues) === null || _l === void 0 ? void 0 : _l.country, errorText: (_m = this.errors) === null || _m === void 0 ? void 0 : _m.country,
            // just for now so we skip handling country specificities
            disabled: true })))));
    }
    static get watchers() { return {
        "address": ["handleAddressChange"]
    }; }
}, [0, "justifi-identity-address-form", {
        "handleFormUpdate": [16],
        "errors": [8],
        "defaultValues": [8, "default-values"],
        "address": [32]
    }, undefined, {
        "address": ["handleAddressChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-identity-address-form", "custom-popper", "form-control-select", "form-control-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, IdentityAddressForm);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { IdentityAddressForm as I, defineCustomElement as d };
